import { parseMinuteUpdownSlug } from '@/domain/crypto/crypto-minute-slug.js';

/** 仅 btc-updown-5m；动效节奏见 updown-flow-timing.js（按 5m 设计） */
export const UPDOWN_FLOW_SLUG_FRAGMENT = 'btc-updown-5m';

export function isUpdownFlowSlug(slug) {
  const parsed = parseMinuteUpdownSlug(slug);
  return parsed?.asset === 'btc' && parsed?.interval === '5m';
}

/** 列表卡片是否展示 updown 飘字（与分钟盘标题拆分无关） */
export function resolveFeedCardShowUpdownFlow(card) {
  if (!card || card.variant !== 'binary') return false;
  if ((card.marketRows || []).length > 1) return false;
  return isUpdownFlowSlug(card.collectionSlug);
}
